import styled from "styled-components";

export const Filters = styled.div`
	margin-top: 20px;
	direction: rtl; 
	display: block;
	padding-right: 26px;
	text-align: right;
`;

export const Header = styled.div`
	display: flex;
	font-size: 12px;
  	font-weight: 500;
	margin-bottom: 16px;
`;

export const Row = styled.div`	
	margin-bottom: 10px;
	font-size: 12px;
`;